<template>

  <b-overlay
    variant="white"
    :show="showLoading"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
  >
    <b-card
      ref="bCard"
      :class="{draft:isDraft}"
      v-bind="cardAttrs"
      no-body
      :aria-controls="parentID"
      :style="cardStyles"
      v-on="$listeners"
    >

      <b-card-header class="customHeader">
        <div
          v-if="showHeader"
          class="d-flex w-100 justify-content-between"
        >
          <!-- Title & SubTitle -->
          <div class="p-2">
            <b-card-title>{{ $attrs.title }} <span v-if="$attrs['drills']>1">
              <feather-icon
                icon="ChevronsRightIcon"
                class="text-danger"
              /> {{ drillsTitle }}
            </span>
            </b-card-title>
            <b-card-sub-title
              v-if="$attrs['sub-title']||$attrs['search']||$attrs['weighted']"
              class="small black"
            >
              {{ $attrs['sub-title'] }} <span
                v-if="$attrs['weighted']"
                class="text-info"
                :title="$t('Weighted')"
              >{{ $t('Weighted') }}</span> <span
                v-if="$attrs['weighted'] && $attrs['unweighted-base']"
                class="text-info"
                :title="$t('Base Un-Weighted')"
              >{{ $t('Base Un-Weighted') }}</span>
              <div>
                <span
                  v-if="$attrs['search']"
                  class="text-danger"
                > {{ $t(' Displaying records contains ') }}<strong> {{ $attrs['search'] }}</strong> {{ $t(' iceren sonuclar gosterilmektedir') }}
                </span> <b-link
                  v-if="$attrs['search']"
                  @click="$emit('clear')"
                >
                  {{ $t('Clear') }}
                </b-link>
              </div>
            </b-card-sub-title>
          </div>
          <div class="p-2">
            <!-- Card Actions -->
            <b-card-actions-container
              v-if="showActions"
              :available-actions="availableActions"
              data-html2canvas-ignore
              :searchable="searchable"
              :currently-in-my-dashboard="currentlyInMyDashboard"
              :is-draft="isDraft"
              @search="triggerSearch"
              @edit="triggerEdit"
              @delete="triggerDelete"
              @download="triggerDownload"
              @clone="triggerClone"
              @clone_to_my_dashboard="triggerCloneToMyDashboard"
              @publish="triggerPublish"
              @drill="triggerDrill"
            />
          </div>
        </div>
      </b-card-header>

      <!-- Handle no-body -->
      <slot v-if="$attrs['no-body'] !== undefined" />
      <b-card-body
        v-else
        :style="cardBodyStyles"
      >
        <slot />
      </b-card-body>
      <b-card-footer
        v-if="showFooter"
        style="height:80px;overflow: hidden;"
      >
        <div class="d-flex w-100 justify-content-between">
          <div>
            <b-link
              v-if="currentBoxIndex>0"
              class="mr-1"
              @click="$emit('drillBack')"
            >
              <feather-icon
                icon="ChevronsLeftIcon"
                size="14"
              /> {{ $t('Go back') }}

            </b-link>
            <small
              v-if="boxDescription||(boxMessage)"
              class="text-gray"
            ><span
              v-if="boxMessage"
              class="text-info"
            ><i>[ {{ $t(boxMessage) }} ]</i></span> <pre>{{ boxDescription }}</pre></small>
          </div>

          <b-pagination
            v-if="showPagination"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            siz="sm"
            pills
            align="right"
            first-number
            last-number
            class="my-0"
            @change="pageChanged"
          />
        </div>

      </b-card-footer>

    </b-card>

  </b-overlay>

</template>

<script>
import {
  BCard, BCardTitle, BCardSubTitle, BCardBody, BOverlay, BLink, BCardFooter, BCardHeader, BPagination,
} from 'bootstrap-vue'
import BCardActionsContainer from './BCardActionsContainer.vue'

export default {
  components: {
    BCardActionsContainer,
    BCard,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    BOverlay,
    BLink,
    BCardFooter,
    BCardHeader,
    BPagination,
  },
  inheritAttrs: false,
  props: {
    inProgress: {
      type: Boolean,
      default: false,
    },
    noActions: {
      type: Boolean,
      default: false,
    },
    actionEdit: {
      type: Boolean,
      default: false,
    },
    actionDelete: {
      type: Boolean,
      default: false,
    },
    actionDownload: {
      type: Boolean,
      default: false,
    },
    actionSearch: {
      type: Boolean,
      default: false,
    },
    actionClone: {
      type: Boolean,
      default: false,
    },
    actionCloneToMyDashboard: {
      type: Boolean,
      default: false,
    },
    actionDrill: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    currentlyInMyDashboard: {
      type: Boolean,
      default: false,
    },
    isDraft: {
      type: Boolean,
      default: false,
    },
    currentBoxIndex: {
      type: Number,
      default: 0,
    },
    boxDescription: {
      type: String,
      default: null,
    },
    boxMessage: {
      type: String,
      default: null,
    },
    showPagination: {
      type: Boolean,
      default: false,
    },
    pageInfo: {
      type: Number,
      default: null,
    },
    totalRows: {
      type: Number,
      default: null,
    },
    perPage: {
      type: Number,
      default: 50,
    },
    boxHeight: {
      type: Number,
      default: 300,
    },
    drillsTitle: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      parentID: '',
      showLoading: false,
      cardStyles: {},
    }
  },
  computed: {
    showFooter() {
      if (this.boxDescription || this.boxMessage || this.showPagination || this.currentBoxIndex) return true
      return false
    },
    currentPage: {
      set(pageInfo) {
        this.$emit('input', pageInfo)
      },
      get() {
        return this.pageInfo
      },
    },
    cardAttrs() {
      const cardAttrs = JSON.parse(JSON.stringify(this.$attrs))
      delete cardAttrs.title
      delete cardAttrs['sub-title']
      return cardAttrs
    },
    showHeader() {
      return this.$attrs.title || this.$attrs['sub-title'] || !this.noActions
    },
    showActions() {
      if (this.noActions) return false
      return true
    },
    availableActions() {
      const actions = []
      const allFalse = (this.actionEdit || this.actionDelete || this.actionDownload || this.actionSearch || this.actionClone || this.actionCloneToMyDashboard || this.actionDrill) === false

      if (this.actionEdit || allFalse) actions.push('edit')
      if (this.actionDelete || allFalse) actions.push('delete')
      if (this.actionDownload || allFalse) actions.push('download')
      if (this.actionSearch || allFalse) actions.push('search')
      if (this.actionClone || allFalse) actions.push('clone')
      if (this.actionCloneToMyDashboard || allFalse) actions.push('clone_to_my_dashboard')
      if (this.actionDrill || allFalse) actions.push('drill')
      return actions
    },
    cardBodyStyles() {
      const styles = {}
      if (this.showFooter) {
        // eslint-disable-next-line radix
        styles.height = `${parseInt(this.boxHeight) - 80}px`
      } else {
        styles.height = `${this.boxHeight}px`
      }
      styles.overflow = 'hidden'
      return styles
    },
  },
  watch: {
    inProgress() {
      this.showLoading = false
      if (this.inProgress) {
        this.showLoading = true
      }
    },
  },
  created() {
    this.parentID = String(Math.floor(Math.random() * 10) + 1)
  },
  methods: {
    pageChanged(val) {
      this.$emit('pageChanged', val)
    },
    triggerEdit() {
      this.$emit('edit')
    },
    triggerDelete() {
      this.$emit('delete')
    },
    triggerDownload() {
      this.$emit('download')
    },
    triggerSearch() {
      this.$emit('search')
    },
    triggerClone() {
      this.$emit('clone')
    },
    triggerCloneToMyDashboard() {
      this.$emit('clone_to_my_dashboard')
    },
    triggerDrill() {
      this.$emit('drill')
    },
    triggerPublish() {
      this.$emit('publish')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.card {
  ::v-deep .card-header {
    .heading-elements {
      position: static;
      cursor: inherit;

      .list-inline {
        display: block;

        li {
          a {
            padding: 0;
          }

          &:not(:last-child) {
            margin-right: 1rem;
          }
        }
      }
    }
  }
}

.dark-layout {
  .b-overlay-wrap ::v-deep .b-overlay {
    // border: 10px solid red;
    .bg-white {
      background-color: $theme-dark-body-bg !important;
    }
  }
}
.draft{ border:#ff0000 1px dashed;}
.customHeader{
  height:100px;
  padding: 0;
  display: inherit !important;
  align-items: inherit !important;
}
.card-subtitle{
  margin-top: 6px !important;
}
li {
  background-color: red !important;
}
.card-footer{
  border-top: 0 !important;
}
pre {
  background-color: #ffffff !important;
}
</style>
